import QuickbooksChooseAccount from "../Layout/stepUtils/QuickbooksChooseAccount";
import CustomerForm from "../Layout/Quickbooks/CustomerForm";
import SendDataToQuickbooks from "../Layout/Quickbooks/SendDataToQuickbooks";
import QuickbooksItemForm from "../Layout/Quickbooks/QuickbooksItemForm";
import QuickbooksInvoiceForm from "../Layout/Quickbooks/QuickbooksInvoiceForm";
import QuickbooksPaymentForm from "../Layout/Quickbooks/QuickbooksPaymentForm";
import PaymentCustomFindWithTriggerForQuickbooks from "../Layout/Salesforce/PaymentCustomFindWithTriggerForQuickbooks";
import ContactUpdateForm from "../Layout/Quickbooks/ContactUpdateForm";
import SalesObjDataFindForQuickbooks from "../Layout/Salesforce/SalesObjDataFindForQuickbooks";
import ProductUpdateForm from "../Layout/Quickbooks/ProductUpdateForm";
import QuickbooksInvoiceUpdateForm from "../Layout/Quickbooks/QuickbooksInvoiceUpdateForm";
import { AddQuickbooksWebhook } from "../Layout/Quickbooks/AddQuickbooksWebhook";
import { api } from "../Http";
import { ENVIRONMENT } from "../Http/API";
import ChooseAccount from "../Layout/stepUtils/ChooseAccount";
import SelectTriggerObject from "../Layout/Salesforce/SelectTriggerObject";
import TestTrigger from "../Layout/Salesforce/TestTrigger";

const callback = ENVIRONMENT;

const SFDC_CALLBACK = callback.sfdc_callback;
const SFDC_CLIENT_ID = callback.sfc_client_id;

const SFDC_COMMON = [
  {
    title: "Choose Account",
    content: () => (
      <ChooseAccount
        authRequestFunction={(environment, cb) => {
          window.SFDC_ENV = environment;
          const url = `https://${environment}.salesforce.com/services/oauth2/authorize?response_type=code&client_id=${SFDC_CLIENT_ID}&redirect_uri=${SFDC_CALLBACK}`;
          const popWindow = window.open(
            url,
            "newwindow",
            "width=1000,height=600",
          );
          const syncWindow = setInterval(() => {
            //console.log('open');
            if (popWindow.closed) {
              cb();
              //console.log('closed');
              clearInterval(syncWindow);
            }
          }, 500);
        }}
      />
    ),
  },
];

const QUICKBOOKS_COMMON = [
  {
    title: "Choosed Account",
    content: () => (
      <QuickbooksChooseAccount
        authRequestFunction={(qckbEnv, cb) => {
          api
            .get(`/api/quickbooks?qckbEnv=${qckbEnv}`)
            .then((resp) => {
              if (resp.data.code === 0) {
                const popWindow = window.open(
                  resp.data.data,
                  "newwindow",
                  "width=800,height=600",
                );
                const syncWindow = setInterval(() => {
                  console.log("open");
                  if (popWindow.closed) {
                    cb();
                    console.log("closed");
                    clearInterval(syncWindow);
                  }
                }, 500);
              }
            })
            .catch((e) => console.log(e));
        }}
      />
    ),
  },
];

const QUICKBOOKS_UPDATE_RECORD = {
  steps: [
    ...QUICKBOOKS_COMMON,
    {
      title: "Enable Webhook",
      content: () => <AddQuickbooksWebhook />,
    },
  ],
};
const SFDC_UPDATE_CONTACT_RECORD = {
  steps: [
    ...SFDC_COMMON,
    {
      title: "Customize Record",
      content: () => <SalesObjDataFindForQuickbooks />,
    },
    {
      title: "Contact Mapping",
      content: () => <ContactUpdateForm />,
    },
  ],
};
const SFDC_UPDATE_PRODUCT_RECORD = {
  steps: [
    ...SFDC_COMMON,
    {
      title: "Customize Record",
      content: () => <SalesObjDataFindForQuickbooks />,
    },
    {
      title: "Product Mapping",
      content: () => <ProductUpdateForm />,
    },
  ],
};
const SFDC_UPDATE_INVOICE_RECORD = {
  steps: [
    ...SFDC_COMMON,
    {
      title: "Customize Record",
      content: () => <SalesObjDataFindForQuickbooks />,
    },
    {
      title: "Invoice Mapping",
      content: () => <QuickbooksInvoiceUpdateForm />,
    },
  ],
};

const QUICKBOOKS_CREATE_OR_UPDATE_CUSTOMER = {
  steps: [
    ...QUICKBOOKS_COMMON,
    {
      title: "Customize Record",
      content: () => <CustomerForm />,
    },
    {
      title: "Send Data",
      content: () => (
        <SendDataToQuickbooks delegateToUri="/api/quickbooks/delegate" />
      ),
    },
  ],
};

const QUICKBOOKS_CREATE_OR_UPDATE_ITEM = {
  steps: [
    ...QUICKBOOKS_COMMON,
    {
      title: "Customize Record",
      content: () => <QuickbooksItemForm />,
    },
    {
      title: "Send Data",
      content: () => (
        <SendDataToQuickbooks delegateToUri="/api/quickbooks/delegate" />
      ),
    },
  ],
};

const QUICKBOOKS_CREATE_INVOICE = {
  steps: [
    ...QUICKBOOKS_COMMON,
    {
      title: "Customize Record",
      content: () => <QuickbooksInvoiceForm />,
    },
    {
      title: "Send Data",
      content: () => (
        <SendDataToQuickbooks delegateToUri="/api/quickbooks/delegate" />
      ),
    },
  ],
};
const QUICKBOOKS_NEW_PAYMENT_RECORD = {
  steps: [
    ...QUICKBOOKS_COMMON,
    {
      title: "Enable Webhook",
      content: () => <AddQuickbooksWebhook />,
    },
  ],
};
const SFDC_SYNC_QUICKBOOK_PAYMENT = {
  steps: [
    ...SFDC_COMMON,

    {
      title: "Find Salesforce Object",
      content: () => <SelectTriggerObject />,
    },
    {
      title: "Find Data",
      content: () => <TestTrigger showNext={true} />,
    },
    {
      title: "Find Parent Record",
      content: () => <PaymentCustomFindWithTriggerForQuickbooks />,
    },
    {
      title: "Payment Mapping",
      content: () => <QuickbooksPaymentForm />,
    },
  ],
};

export {
  QUICKBOOKS_CREATE_OR_UPDATE_CUSTOMER,
  QUICKBOOKS_CREATE_OR_UPDATE_ITEM,
  QUICKBOOKS_CREATE_INVOICE,
  SFDC_UPDATE_CONTACT_RECORD,
  SFDC_UPDATE_PRODUCT_RECORD,
  SFDC_UPDATE_INVOICE_RECORD,
  QUICKBOOKS_UPDATE_RECORD,
  QUICKBOOKS_NEW_PAYMENT_RECORD,
  SFDC_SYNC_QUICKBOOK_PAYMENT,
};
